export default "__VITE_ASSET__b680fcde__"